import { getCookie, setCookie } from '../providers/CookieManagementProvider';

const utmManager = (searchParams: URLSearchParams): void => {
  const utm_datas: any = {
    gad_source: searchParams.has('gad_source') ? searchParams.get('gad_source') : '',
    gclid: searchParams.has('gclid') ? searchParams.get('gclid') : '',
    utm_source: searchParams.has('utm_source') ? searchParams.get('utm_source') : '',
    bp_id: searchParams.has('bp_id') ? searchParams.get('bp_id') : '',
    utm_medium: searchParams.has('utm_medium') ? searchParams.get('utm_medium') : '',
    utm_campaign: searchParams.has('utm_campaign') ? searchParams.get('utm_campaign') : '',
    utm_content: searchParams.has('utm_content') ? searchParams.get('utm_content') : '',
    utm_term: searchParams.has('utm_term') ? searchParams.get('utm_term') : '',
    fbclid: searchParams.has('fbclid') ? searchParams.get('fbclid') : '',
  };

  if (window.navigator.cookieEnabled) {
    for (const key in utm_datas) {
      if (getCookie('utm_datas') && key == 'bp_id') {
        try {
          const utm_datas_cookie = JSON.parse(getCookie('utm_datas') as string);

          if (utm_datas_cookie.bp_id) {
            delete utm_datas[key];
          }
        } catch {
          // Ignore JSON parse errors for UTM cookie
        }
      }

      if (utm_datas[key] === '') {
        delete utm_datas[key];
      }
    }

    if (Object.keys(utm_datas).length > 0) setCookie('utm_datas', JSON.stringify(utm_datas), 30);
  }
};

const Utils = {
  utmManager,
};

export default Utils;
